import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, concatMap, mergeMap } from 'rxjs';
import * as widgetColumnActions from '../actions/widget-columns.actions';
import { WidgetColumnsHttpService } from '../services/widget-columns-http.service';


@Injectable()
export class WidgetColumnsEffects {

  loadAvailableColumns = createEffect(() => this.actions.pipe(
    ofType(widgetColumnActions.apiLoadAvailableColumns),
    concatMap(({ widget }) => this.api.getAvailableColumns(widget.id)
      .pipe(map(columns => widgetColumnActions.apiLoadColumnsComplete({ widget, columns }))))
  ));

  resetColumns = createEffect(() => this.actions.pipe(
    ofType(widgetColumnActions.apiResetColumns),
    concatMap(({ widget }) => this.api.resetColumns(widget.id)
      .pipe(map(columns => widgetColumnActions.apiResetColumnsComplete({ widget, columns }))))
  ));

  resizeColumns = createEffect(() => this.actions.pipe(
    ofType(widgetColumnActions.apiResizeColumn),
    concatMap(({ column, widget }) => this.api.resizeColumn(widget.id, column)
      .pipe(map(() => widgetColumnActions.apiResizeColumnComplete({ widget }))))
  ));

  reorderColumns = createEffect(() => this.actions.pipe(
    ofType(widgetColumnActions.apiReorderColumns),
    concatMap(({ widget, columnFieldNames }) => this.api.reorderColumns(widget.id, columnFieldNames)
      .pipe(map(() => widgetColumnActions.apiReorderColumnsComplete({ widget }))))
  ));

  changeSelectedColumns = createEffect(() => this.actions.pipe(
    ofType(widgetColumnActions.apiChangeSelectedColumns),
    concatMap(({ columns, widget }) => this.api.changeSelectedColumns(widget.id, columns)
      .pipe(map((columns) => widgetColumnActions.apiChangeSelectedComplete({ columns, widget }))))
  ));


  changeSelectedColumnsComplete = createEffect(() =>
    this.actions.pipe(
      ofType(widgetColumnActions.apiChangeSelectedComplete),
      mergeMap(payload => [
        widgetColumnActions.apiLoadAvailableColumns({widget: payload.widget})
      ]))
  );

  constructor(
    private readonly api: WidgetColumnsHttpService,
    private readonly actions: Actions) { }

}
